<blockquote class="border-l-4 border-gray-200 px-4 py-2 dark:border-gray-800"><slot /></blockquote>
